<template>
    <div class="order">
        <div style="margin-bottom:10px;">
            <el-button @click="exportExcel" type="success" size="small">导出订单明细</el-button>
        </div>
        <div>
            <table>
                <thead>
                    <tr class="th">
                        <td>下单人</td>
                        <td>订单号</td>
                        <td>支付方式</td>
                        <td>订单金额</td>
                        <td>下单时间</td>
                        <td>订单状态</td>
                        <td>操作</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in orderList.list" :key="index">
                        <td>{{ item.realName }}</td>
                        <td>{{ item.orderNo }}</td>
                        <td>{{ payWay[item.payWay] }}</td>
                        <td>{{ item.orderMoney }}</td>
                        <td>{{ item.createTime }}</td>
                        <td>{{ orderStatus[item.orderStatus] }}</td>
                        <td>
                            <el-button type="success" size="mini" @click="handleDetail(item)"
                                >查看明细</el-button
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
            <div
                class="table-empty"
                v-if="
                    !orderList || !orderList.list || (orderList.list && orderList.list.length === 0)
                "
            >
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                layout="prev, pager, next, total"
                :total="orderList.count"
                :page-size="orderList.pageSize"
                :current-page="orderList.page"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog title="订单明细" :visible.sync="orderDialog" width="800px">
            <OrderDetail :orderId="currentOrderId"></OrderDetail>
            <div slot="footer" class="dialog-footer"></div>
        </el-dialog>
    </div>
</template>

<script>
import * as apis from '../../fetch/order';

import OrderDetail from '../../components/order/OrderDetail';

export default {
    name: 'order',
    components: {
        OrderDetail,
    },
    data() {
        return {
            formInline: {
                orderNo: '',
                startTime: '',
                endTime: '',
                casCode: '',
                contact: '',
            },
            orderList: [],
            orderStatus: {
                1: '待确认',
                2: '待审核',
                3: '审核通过',
                4: '审核拒绝',
            },
            payWay: {
                1: '账户余额',
                2: '线下支付',
            },
            orderDialog: false,
            currentOrderId: null,
        };
    },
    methods: {
        exportExcel() {
            window.open(window.location.origin + '/tengsaiApi/d-web/order/exportMyOrder');
        },
        getOrder(page = 1) {
            const params = {
                ...this.formInline,
                page,
            };
            if (params.time) {
                params.startTime = this.formInline.time[0];
                params.endTime = this.formInline.time[1];
                delete params.time;
            }
            apis.getOrder(params).then(res => {
                this.orderList = res;
            });
        },
        handleCurrentChange(page) {
            this.getOrder(page);
        },
        handleDetail(item) {
            this.orderDialog = true;
            this.currentOrderId = item.id;
        },
    },
    mounted() {
        this.getOrder();
    },
};
</script>

<style lang="less" scoped></style>
